/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamComponentTypesQueryResponse,
  GetApiV1ExamComponentTypes400,
  GetApiV1ExamComponentTypes401,
  GetApiV1ExamComponentTypes500,
} from "../../types/examSharedController/GetApiV1ExamComponentTypes.ts";

function getGetApiV1ExamComponentTypesUrl() {
  const res = { method: "GET", url: `/api/v1/exam/component-types` as const };
  return res;
}

/**
 * @description Retorna todos os tipos de componentes **(Requer Authorization para autenticação)**
 * @summary Buscar todos os tipos de componentes (Requer Authorization para autenticação)
 * {@link /api/v1/exam/component-types}
 */
export async function getApiV1ExamComponentTypes(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamComponentTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamComponentTypes400
      | GetApiV1ExamComponentTypes401
      | GetApiV1ExamComponentTypes500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamComponentTypesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
